module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar'), _vm._v(" "), _c('div', {
    staticClass: "sidebar bg-darkgrey navbar-inverse side-box-shadow"
  }, [_c('ul', {
    staticClass: "nav flex-column"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-text pull-left",
    attrs: {
      "href": "#/OrderPending"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('OrderCurrent.sidebar.pending')) + "\n        ")]), _vm._v(" "), (_vm.pending.length > 0) ? _c('span', {
    staticClass: "pull-right badge badge-default"
  }, [_vm._v(_vm._s(_vm.pending.length))]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "current"
    }
  }, [_c('a', {
    staticClass: "nav-link navbar-text pull-left",
    attrs: {
      "href": "#/OrderCurrent"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('OrderCurrent.sidebar.current')) + "\n        ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'current': _vm.$route.query.newNote
    }
  }, [_c('router-link', {
    staticClass: "nav-link navbar-text pull-left pr-0",
    attrs: {
      "to": {
        name: 'OrderCurrent',
        query: {
          newNote: true
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('OrderCurrent.sidebar.notes')) + "\n        ")]), _vm._v(" "), (_vm.newCount.newNote > 0) ? _c('span', {
    staticClass: "pull-right badge badge-default"
  }, [_vm._v(_vm._s(_vm.newCount.newNote))]) : _vm._e()], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'current': _vm.$route.query.newDate
    }
  }, [_c('router-link', {
    staticClass: "nav-link navbar-text pull-left pr-0",
    attrs: {
      "to": {
        name: 'OrderCurrent',
        query: {
          newDate: true
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('OrderCurrent.sidebar.date')) + "\n        ")]), _vm._v(" "), (_vm.newCount.newDate > 0) ? _c('span', {
    staticClass: "pull-right badge badge-default"
  }, [_vm._v(_vm._s(_vm.newCount.newDate))]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.customViews), function(view) {
    return _c('li', {
      staticClass: "nav-item",
      class: {
        'current': view.query.name === _vm.$route.query.name
      }
    }, [_c('router-link', {
      staticClass: "nav-link navbar-text pull-left",
      attrs: {
        "to": {
          name: 'OrderCurrent',
          query: view.query
        }
      }
    }, [_vm._v("\n          " + _vm._s(view.query.name) + "\n        ")])], 1)
  }), _vm._v(" "), (_vm.isAdmin) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-kne-orange",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.modal.newCustomView = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-kne-orange",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.modal.deleteCustomView = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-kne-orange col-12 mt-3",
    attrs: {
      "id": "addOrder"
    },
    on: {
      "click": function($event) {
        _vm.addOrderAction();
        _vm.closedModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('OrderPending.sidebar.add_order')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "view"
  }, [_c('div', {
    staticClass: "card mb-3 bg-darkgrey"
  }, [_c('div', {
    staticClass: "color-grey",
    attrs: {
      "id": "stats"
    }
  }, [_c('div', {
    staticClass: "col-12 col-md-6 col-lg-3"
  }, [_c('p', {
    staticClass: "mx-3 my-3"
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.stats.processing')) + ": "), _c('span', {
    staticClass: "pull-right color-white"
  }, [_vm._v(_vm._s(_vm.newCount.processing))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 col-lg-3"
  }, [_c('p', {
    staticClass: "mx-3 my-3"
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.stats.dispatch')) + ": "), _c('span', {
    staticClass: "pull-right color-white"
  }, [_vm._v(_vm._s(_vm.newCount.dispatch))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 col-lg-3"
  }, [_c('p', {
    staticClass: "mx-3 my-3"
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.stats.pick')) + ": "), _c('span', {
    staticClass: "pull-right color-white"
  }, [_vm._v(_vm._s(_vm.newCount.pick))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 col-lg-3"
  }, [_c('p', {
    staticClass: "mx-3 my-3"
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.stats.transit')) + ": "), _c('span', {
    staticClass: "pull-right color-white"
  }, [_vm._v(_vm._s(_vm.newCount.transit))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 col-lg-3"
  }, [_c('p', {
    staticClass: "mx-3 my-3"
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.stats.delivered')) + ": "), _c('span', {
    staticClass: "pull-right color-white"
  }, [_vm._v(_vm._s(_vm.newCount.drop))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 col-lg-3"
  }, [_c('p', {
    staticClass: "mx-3 my-3"
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.stats.transferred')) + ": "), _c('span', {
    staticClass: "pull-right color-white"
  }, [_vm._v(_vm._s(_vm.newCount.transfer))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 col-lg-3"
  }, [_c('p', {
    staticClass: "mx-3 my-3"
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.stats.rejected')) + ": "), _c('span', {
    staticClass: "pull-right color-white"
  }, [_vm._v(_vm._s(_vm.newCount.reject))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 col-lg-3"
  }, [_c('p', {
    staticClass: "mx-3 my-3"
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.stats.waiting')) + ": "), _c('span', {
    staticClass: "pull-right color-white"
  }, [_vm._v(_vm._s(_vm.newCount.waiting))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "orders"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "my-2"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('OrderCurrent.title')) + "\n          "), (_vm.$store.state.userInfo && _vm.$store.state.userInfo.isSageOne) ? _c('button', {
    staticClass: "btn btn-kne-orange",
    attrs: {
      "disabled": _vm.selected.length < 1
    },
    on: {
      "click": function($event) {
        _vm.openBilling()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.actions.billing')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-kne-orange",
    attrs: {
      "disabled": _vm.selected.length < 1
    },
    on: {
      "click": function($event) {
        _vm.openDispatch(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.actions.shortDispatch')))]), _vm._v(" "), (_vm.isAdmin) ? _c('json-excel', {
    staticClass: "btn btn-kne-orange pull-right",
    attrs: {
      "data": JSON.parse(JSON.stringify(_vm.filterResultsWithOrder)),
      "fields": _vm.customers_fields,
      "name": 'order_current_' + _vm.getDate(Date.now()) + '.xls'
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('AddressBook.sidebar.excel')) + "\n          ")]) : _vm._e()], 1)]), _vm._v(" "), _c('paginate', {
    ref: "paginator",
    attrs: {
      "refreshCurrentPage": false,
      "name": "filterResults",
      "tag": "div",
      "list": _vm.filterResults,
      "per": 40
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover font-grey mb-0 table-sm"
  }, [_c('thead', {
    staticClass: "bg-darkgrey"
  }, [_c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('.key', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.order'))), (_vm.sort.current === '.key') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('numRef', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.reference'))), (_vm.sort.current === 'numRef') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('source', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.source'))), (_vm.sort.current === 'source') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('vin', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.VIN'))), (_vm.sort.current === 'vin') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.isDateRoute) ? _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('datePromis', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.datePromis'))), (_vm.sort.current === 'datePromis') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('creationDate', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.date'))), (_vm.sort.current === 'creationDate') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('transmitterName', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.pickup'))), (_vm.sort.current === 'transmitterName') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('receiverName', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.delivery'))), (_vm.sort.current === 'receiverName') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('payerName', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.billing'))), (_vm.sort.current === 'payerName') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('status', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.status'))), (_vm.sort.current === 'status') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('driverName', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.driver'))), (_vm.sort.current === 'driverName') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "tbody"
    }
  }, [_c('tr', {
    key: "filter"
  }, [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields['.key'],
      "placeholder": _vm.$t('OrderCurrent.order')
    },
    on: {
      "input": function($event) {
        _vm.evaluateFiltering('.key', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.numRef,
      "placeholder": _vm.$t('OrderCurrent.reference')
    },
    on: {
      "input": function($event) {
        _vm.evaluateFiltering('numRef', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.source,
      "placeholder": _vm.$t('OrderCurrent.source')
    },
    on: {
      "input": function($event) {
        _vm.evaluateFiltering('source', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.vin,
      "placeholder": _vm.$t('OrderCurrent.VIN')
    },
    on: {
      "input": function($event) {
        _vm.evaluateFiltering('vin', $event)
      }
    }
  })], 1), _vm._v(" "), (_vm.isDateRoute) ? _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.datePromis,
      "placeholder": _vm.$t('OrderCurrent.datePromis')
    },
    on: {
      "input": function($event) {
        _vm.evaluateFiltering('datePromis', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.creationDate,
      "placeholder": _vm.$t('OrderCurrent.date')
    },
    on: {
      "input": function($event) {
        _vm.evaluateFiltering('creationDate', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.transmitterName,
      "placeholder": _vm.$t('OrderCurrent.pickup')
    },
    on: {
      "input": function($event) {
        _vm.evaluateFiltering('transmitterName', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.receiverName,
      "placeholder": _vm.$t('OrderCurrent.delivery')
    },
    on: {
      "input": function($event) {
        _vm.evaluateFiltering('receiverName', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.payerName,
      "placeholder": _vm.$t('OrderCurrent.billing')
    },
    on: {
      "input": function($event) {
        _vm.evaluateFiltering('payerName', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.status,
      "placeholder": _vm.$t('OrderCurrent.status')
    },
    on: {
      "input": function($event) {
        _vm.evaluateFiltering('status', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.driverName,
      "placeholder": _vm.$t('OrderCurrent.driver')
    },
    on: {
      "input": function($event) {
        _vm.evaluateFiltering('driverName', $event)
      }
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.paginated('filterResults')), function(order) {
    return _c('tr', {
      key: order['.key'],
      class: {
        'drop': order.status === 'Drop', 'cancel': order.status === 'Cancel', 'waiting': order.status === 'Attente', 'pick': order.status === 'Pick', 'transit': order.status === 'Transit', 'dispatch': order.status === 'Dispatch', 'reject': order.status === 'Reject',
      }
    }, [_c('td', [_c('label', {
      staticClass: "custom-control custom-checkbox my-2 ml-2 mr-0"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected),
        expression: "selected"
      }],
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": order['.key'],
        "checked": Array.isArray(_vm.selected) ? _vm._i(_vm.selected, order['.key']) > -1 : (_vm.selected)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = order['.key'],
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-indicator"
    })])]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'OrderInfo',
          query: {
            orderId: order['.key']
          }
        }
      }
    }, [_c('input', {
      staticClass: "btn btn-kne-orange",
      attrs: {
        "type": "button",
        "value": _vm.$t('OrderCurrent.view')
      }
    })])], 1), _vm._v(" "), (!_vm.isDateRoute) ? _c('td', [_c('a', {
      attrs: {
        "href": order.invoice,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          _vm.print(order)
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-kne-orange",
      class: {
        'printed': order.isPrinted
      }
    }, [_c('i', {
      staticClass: "fa fa-print",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]) : _vm._e(), _vm._v(" "), (_vm.isDateRoute) ? _c('td', [(_vm.checkDate(order.datePromis)) ? _c('input', {
      staticClass: "btn btn-kne-red",
      attrs: {
        "type": "button",
        "value": _vm.calcBusinessDays(order.datePromis)
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.checkDate(order.datePromis)) ? _c('input', {
      staticClass: "btn btn-kne-green",
      attrs: {
        "type": "button",
        "value": _vm.calcBusinessDays2(order.datePromis)
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(order['.key']))]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(order.numRef))]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(order.source))])]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(order.vin))]), _vm._v(" "), (_vm.isDateRoute) ? _c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(order.datePromis))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(_vm.getDate(order.creationDate)))]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(order.transmitterName))])]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(order.receiverName))])]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(order.payerName))])]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [(order.status === 'Dispatch') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.dispatch')))]) : _vm._e(), _vm._v(" "), (order.status === 'Processing') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.processing')))]) : _vm._e(), _vm._v(" "), (order.status === 'Pick') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.pick')))]) : _vm._e(), _vm._v(" "), (order.status === 'Attente') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.waiting')))]) : _vm._e(), _vm._v(" "), (order.status === 'Transit') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.transit')))]) : _vm._e(), _vm._v(" "), (order.status === 'Drop') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.drop')))]) : _vm._e(), _vm._v(" "), (order.status === 'Cancel') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.canceled')))]) : _vm._e(), _vm._v(" "), (order.status === 'Terminée') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.finished')))]) : _vm._e(), _vm._v(" "), (order.status === 'Transférée') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.transfered')))]) : _vm._e(), _vm._v(" "), (order.status === 'Reject') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.rejected')))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(order.driverName))])])])
  })], 2)], 1)])]), _vm._v(" "), _c('paginate-links', {
    attrs: {
      "for": "filterResults",
      "hide-single-page": true,
      "limit": 5
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.closedModal !== true) ? _c('modal', {
    attrs: {
      "closable": ""
    },
    on: {
      "close-request": function($event) {
        _vm.closedModal = true;
        _vm.clear()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-6 pr-0",
    attrs: {
      "id": "Order"
    }
  }, [_c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.orderTab.order')))]), _vm._v(" "), _c('div', {}, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.source,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.orderTab.source')
    },
    on: {
      "input": function($event) {
        _vm.order.source = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {}, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.datePromis,
      "type": "date",
      "placeholder": _vm.$t('OrderPending.orderTab.datePromis')
    },
    on: {
      "input": function($event) {
        _vm.order.datePromis = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {}, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.numRef,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.orderTab.reference')
    },
    on: {
      "input": function($event) {
        _vm.order.numRef = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {}, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.price,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.orderTab.price')
    },
    on: {
      "input": function($event) {
        _vm.order.price = $event
      }
    }
  }), _vm._v(" "), _c('regular-textarea', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.comment,
      "rows": "4",
      "placeholder": _vm.$t('OrderPending.orderTab.comment')
    },
    on: {
      "input": function($event) {
        _vm.order.comment = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 pl-0",
    attrs: {
      "id": "vehicle"
    }
  }, [_c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.vehicleInfoTab.vehicle_info')))]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.VIN,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.vehicleInfoTab.VIN')
    },
    on: {
      "input": function($event) {
        _vm.VIN = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100 form-group",
    attrs: {
      "disabled": _vm.VIN === ''
    },
    on: {
      "click": function($event) {
        _vm.validate(_vm.VIN)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.vehicleInfoTab.validate')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.MAKE,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.vehicleInfoTab.make')
    },
    on: {
      "input": function($event) {
        _vm.MAKE = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.MODEL,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.vehicleInfoTab.model')
    },
    on: {
      "input": function($event) {
        _vm.MODEL = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.YEAR,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.vehicleInfoTab.year')
    },
    on: {
      "input": function($event) {
        _vm.YEAR = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100 form-group",
    on: {
      "click": function($event) {
        _vm.addVehicle()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.vehicleInfoTab.add_vehicle')))])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', {}, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderPending.vehicleInfoTab.VIN')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderPending.vehicleInfoTab.year')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderPending.vehicleInfoTab.make')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderPending.vehicleInfoTab.model')))])])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "tbody"
    }
  }, _vm._l((_vm.vehicles), function(vehicle, index) {
    return _c('tr', {
      key: vehicle.vin + vehicle.year
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(vehicle.vin))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(vehicle.year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(vehicle.make))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(vehicle.model))])])
  }))], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "mt-3 col-4 pr-0",
    attrs: {
      "id": "pickup"
    }
  }, [_c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.pickupDeliveryTab.pickup')))]), _vm._v(" "), _c('regular-datalist', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.datalist.pickup,
      "originalList": _vm.$store.state.allContacts,
      "secondList": _vm.addressbook,
      "placeholder": _vm.$t('AddressBook.title')
    },
    on: {
      "input": function($event) {
        _vm.setAndSearch($event, 'pickup')
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterName,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.name') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterName = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterAddress,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.address') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterAddress = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterCity,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.city')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterCity = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterPostcode,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.postal_code')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterPostcode = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterProvince,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.province')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterProvince = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterCountry,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.country')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterCountry = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterEmail,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.email')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterEmail = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterPhone,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.phone')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterPhone = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterFax,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.fax')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterFax = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterContact,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.contact')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterContact = $event
      }
    }
  }), _vm._v(" "), _c('regular-checkbox', {
    staticClass: "col-12",
    attrs: {
      "checked": _vm.pickupSave,
      "label": _vm.$t('OrderPending.pickupDeliveryTab.save_dealer')
    },
    on: {
      "change": function($event) {
        _vm.pickupSave = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-4 px-0",
    attrs: {
      "id": "delivery"
    }
  }, [_c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.pickupDeliveryTab.delivery')))]), _vm._v(" "), _c('regular-datalist', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.datalist.delivery,
      "originalList": _vm.$store.state.allContacts,
      "secondList": _vm.addressbook,
      "placeholder": _vm.$t('AddressBook.title')
    },
    on: {
      "input": function($event) {
        _vm.setAndSearch($event, 'delivery')
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverName,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.name') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.receiverName = $event;
        _vm.onInputBillingSame()
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverAddress,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.address') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.receiverAddress = $event;
        _vm.onInputBillingSame()
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverCity,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.city')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverCity = $event;
        _vm.onInputBillingSame()
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverPostcode,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.postal_code')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverPostcode = $event;
        _vm.onInputBillingSame()
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverProvince,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.province')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverProvince = $event;
        _vm.onInputBillingSame()
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverCountry,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.country')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverCountry = $event;
        _vm.onInputBillingSame()
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverEmail,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.email')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverEmail = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverPhone,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.phone')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverPhone = $event;
        _vm.onInputBillingSame()
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverFax,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.fax')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverFax = $event;
        _vm.onInputBillingSame()
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverContact,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.contact')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverContact = $event;
        _vm.onInputBillingSame()
      }
    }
  }), _vm._v(" "), _c('regular-checkbox', {
    staticClass: "col-12",
    attrs: {
      "checked": _vm.deliverySave,
      "label": _vm.$t('OrderPending.pickupDeliveryTab.save_dealer')
    },
    on: {
      "change": function($event) {
        _vm.deliverySave = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-4 pl-0",
    attrs: {
      "id": "billing"
    }
  }, [_c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.pickupDeliveryTab.billing')))]), _vm._v(" "), _c('regular-datalist', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.datalist.billing,
      "disabled": _vm.billingSame,
      "originalList": _vm.$store.state.allContacts,
      "secondList": _vm.isSageOne ? _vm.sageIDonly : _vm.addressbook,
      "placeholder": _vm.$t('AddressBook.title')
    },
    on: {
      "input": function($event) {
        _vm.setAndSearch($event, 'billing')
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerName,
      "disabled": _vm.billingSame,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.name') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.payerName = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerAddress,
      "disabled": _vm.billingSame,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.address') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.payerAddress = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerCity,
      "disabled": _vm.billingSame,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.city')
    },
    on: {
      "input": function($event) {
        _vm.order.payerCity = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerPostcode,
      "disabled": _vm.billingSame,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.postal_code')
    },
    on: {
      "input": function($event) {
        _vm.order.payerPostcode = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerProvince,
      "disabled": _vm.billingSame,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.province')
    },
    on: {
      "input": function($event) {
        _vm.order.payerProvince = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerCountry,
      "disabled": _vm.billingSame,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.country')
    },
    on: {
      "input": function($event) {
        _vm.order.payerCountry = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerEmail,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.email')
    },
    on: {
      "input": function($event) {
        _vm.order.payerEmail = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerPhone,
      "disabled": _vm.billingSame,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.phone')
    },
    on: {
      "input": function($event) {
        _vm.order.payerPhone = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerFax,
      "disabled": _vm.billingSame,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.fax')
    },
    on: {
      "input": function($event) {
        _vm.order.payerFax = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerContact,
      "disabled": _vm.billingSame,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.contact')
    },
    on: {
      "input": function($event) {
        _vm.order.payerContact = $event
      }
    }
  }), _vm._v(" "), _c('regular-checkbox', {
    staticClass: "col-12",
    attrs: {
      "checked": _vm.billingSame,
      "label": _vm.$t('OrderPending.pickupDeliveryTab.same_as_delivery')
    },
    on: {
      "change": function($event) {
        _vm.billingSame = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100",
    attrs: {
      "disabled": !_vm.formCompleted || !_vm.sageOneCheck
    },
    on: {
      "click": function($event) {
        _vm.addOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.submitOrder')))])])]) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.billing || _vm.dispatch || _vm.shortDispatch) ? _c('modal', {
    attrs: {
      "closable": ""
    },
    on: {
      "close-request": function($event) {
        _vm.billing = false;
        _vm.dispatch = false;
        _vm.shortDispatch = false;
        _vm.clear()
      }
    }
  }, [(_vm.billing) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('OrderCurrent.actions.billing'))), _c('span', {
    staticClass: "pull-right h6 mt-2"
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.count')) + " " + _vm._s(_vm.selected.length))])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover font-grey mb-0 table-sm"
  }, [_c('thead', {
    staticClass: "bg-darkgrey"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('OrderCurrent.order')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderCurrent.payer')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderCurrent.sageID')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderCurrent.price')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderCurrent.taxes')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderCurrent.taxescomment')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderCurrent.billingDate')))])])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "tbody"
    }
  }, _vm._l((_vm.selectedFull), function(order, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(_vm.selected[index]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedFull[index].payerName))]), _vm._v(" "), _c('td', [(order.sageID && order.sageID !== '') ? _c('i', {
      staticClass: "fa fa-check",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_c('regular-input', {
      attrs: {
        "min": "0",
        "value": order.price,
        "type": "number",
        "placeholder": _vm.$t('OrderCurrent.price')
      },
      on: {
        "input": function($event) {
          order.price = $event
        }
      }
    })], 1), _vm._v(" "), _c('td', [_c('regular-select', {
      attrs: {
        "value": order.taxes,
        "placeholder": _vm.$t('OrderInfo.modal.tax')
      },
      on: {
        "change": function($event) {
          order.taxes = $event
        }
      }
    }, _vm._l((_vm.$store.state.provinces), function(province) {
      return _c('option', {
        domProps: {
          "value": province
        }
      }, [_vm._v(_vm._s(province))])
    }))], 1), _vm._v(" "), _c('td', [_c('regular-input', {
      attrs: {
        "value": order.taxesComment,
        "type": "text",
        "placeholder": _vm.$t('OrderCurrent.taxescomment')
      },
      on: {
        "input": function($event) {
          order.taxesComment = $event
        }
      }
    })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
      attrs: {
        "value": order.billingDate,
        "type": "date",
        "placeholder": _vm.$t('OrderCurrent.billingDate')
      },
      on: {
        "input": function($event) {
          order.billingDate = _vm.formatDate($event)
        }
      }
    }), _vm._v(" "), (index === 0) ? _c('button', {
      staticClass: "mt-1 btn btn-kne-orange w-100",
      on: {
        "click": function($event) {
          _vm.applyBillingDateToAll(order.billingDate)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.sameBillingDate')))]) : _vm._e()], 1)])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right mt-3"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://mysageone.ca.sageone.com/oauth2/auth?response_type=code&client_id=3ff1477e6ec457b7df62&redirect_uri=https://systems.keepneye.com/api4/SageoneToken&scope=full_access&transpuid=' + _vm.companyUID + '&commandid=' + _vm.allOrderID
    }
  }, [_c('button', {
    staticClass: "btn btn-kne-orange",
    attrs: {
      "disabled": !_vm.allBillingFieldCompleted
    },
    on: {
      "click": function($event) {
        _vm.saveBilling()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.modal.confirm')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.billing = false;
        _vm.clear()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.modal.cancel')))])])])]) : _vm._e(), _vm._v(" "), (_vm.dispatch) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('OrderCurrent.actions.dispatch')))]), _vm._v(" "), (_vm.dispatch) ? _c('regular-datalist-driver', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.dispatchOrder.chauffeurName,
      "secondList": _vm.liste,
      "placeholder": _vm.$t('OrderInfo.modal.driver')
    },
    on: {
      "input": function($event) {
        _vm.dispatchOrder.chauffeurName = $event.value;
        _vm.dispatchOrder.chauffeur = $event.key
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-content row"
  }, [_c('div', {
    staticClass: "mt-3 col-6 pr-0",
    attrs: {
      "id": "pickup"
    }
  }, [_c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.pickup.title')))]), _vm._v(" "), _c('regular-datalist', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.datalist.pickup,
      "originalList": _vm.$store.state.allContacts,
      "secondList": _vm.addressbook,
      "placeholder": _vm.$t('AddressBook.title')
    },
    on: {
      "input": function($event) {
        _vm.setAndSearch($event, 'pickup')
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterName,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.name') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterName = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterAddress,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.address') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterAddress = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterCity,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.city')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterCity = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterPostcode,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.postal_code')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterPostcode = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterProvince,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.province')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterProvince = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterCountry,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.country')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterCountry = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterEmail,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.email')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterEmail = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterPhone,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.phone')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterPhone = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterFax,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.fax')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterFax = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterContact,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.contact')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterContact = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-6 pl-0",
    attrs: {
      "id": "delivery"
    }
  }, [_c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.delivery.title')))]), _vm._v(" "), _c('regular-datalist', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.datalist.delivery,
      "originalList": _vm.$store.state.allContacts,
      "secondList": _vm.addressbook,
      "placeholder": _vm.$t('AddressBook.title')
    },
    on: {
      "input": function($event) {
        _vm.setAndSearch($event, 'delivery')
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverName,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.name') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.receiverName = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverAddress,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.address') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.receiverAddress = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverCity,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.city')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverCity = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverPostcode,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.postal_code')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverPostcode = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverProvince,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.province')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverProvince = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverCountry,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.country')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverCountry = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverEmail,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.email')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverEmail = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverPhone,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.phone')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverPhone = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverFax,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.fax')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverFax = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverContact,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.contact')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverContact = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v("Information")]), _vm._v(" "), _c('div', {
    staticClass: " pt-4"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.order.numRef,
      "type": "text",
      "placeholder": _vm.$t('OrderInfo.modal.reference')
    },
    on: {
      "input": function($event) {
        _vm.order.numRef = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.order.price,
      "type": "number",
      "placeholder": _vm.$t('OrderInfo.modal.price')
    },
    on: {
      "input": function($event) {
        _vm.order.price = $event
      }
    }
  }), _vm._v(" "), _c('regular-textarea', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.comment,
      "placeholder": _vm.$t('OrderInfo.modal.comment'),
      "rows": "6"
    },
    on: {
      "input": function($event) {
        _vm.order.comment = $event
      }
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-kne-orange w-100",
    attrs: {
      "disabled": !_vm.dispatchFormFilled
    },
    on: {
      "click": function($event) {
        _vm.dispatchAction()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.dispatch')))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.shortDispatch) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('OrderCurrent.actions.shortDispatch'))), _c('span', {
    staticClass: "pull-right h6 mt-2"
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.count')) + " " + _vm._s(_vm.selected.length))])]), _vm._v(" "), _c('regular-datalist-driver', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.dispatchOrder.chauffeurName,
      "secondList": _vm.liste,
      "placeholder": _vm.$t('OrderInfo.modal.driver')
    },
    on: {
      "input": function($event) {
        _vm.dispatchOrder.chauffeurName = $event.value;
        _vm.dispatchOrder.chauffeur = $event.key
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover font-grey mb-0 table-sm"
  }, [_c('thead', {
    staticClass: "bg-darkgrey"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('OrderCurrent.order')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.pickup.title')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.delivery.title')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderCurrent.price')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderInfo.modal.reference')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderCurrent.taxescomment')))])])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "tbody"
    }
  }, _vm._l((_vm.selectedFull), function(order, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(_vm.selected[index]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedFull[index].transmitterName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedFull[index].receiverName))]), _vm._v(" "), _c('td', [_c('regular-input', {
      attrs: {
        "min": "0",
        "value": order.price,
        "type": "number",
        "placeholder": _vm.$t('OrderCurrent.price')
      },
      on: {
        "input": function($event) {
          order.price = $event
        }
      }
    })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
      attrs: {
        "min": "0",
        "value": order.numRef,
        "type": "text",
        "placeholder": _vm.$t('OrderInfo.modal.reference')
      },
      on: {
        "input": function($event) {
          order.numRef = $event
        }
      }
    })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
      attrs: {
        "value": order.comment,
        "type": "text",
        "placeholder": _vm.$t('OrderCurrent.taxescomment')
      },
      on: {
        "input": function($event) {
          order.comment = $event
        }
      }
    })], 1)])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right mt-3"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange",
    attrs: {
      "disabled": _vm.dispatchOrder.chauffeur === null || _vm.dispatchOrder.chauffeur === ''
    },
    on: {
      "click": function($event) {
        _vm.shortDispatchAction()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.modal.confirm')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.shortDispatch = false;
        _vm.clear()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.modal.cancel')))])])])], 1) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.modal.newCustomView) ? _c('modal', {
    attrs: {
      "closable": ""
    },
    on: {
      "close-request": function($event) {
        _vm.modal.newCustomView = false;
        _vm.clear()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('OrderCurrent.sidebar.add_custom_view')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.newCustomView.name,
      "type": "text",
      "placeholder": _vm.$t('OrderCurrent.modal.name')
    },
    on: {
      "input": function($event) {
        _vm.newCustomView.name = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.newCustomView.VIN,
      "type": "text",
      "placeholder": _vm.$t('Search.VIN')
    },
    on: {
      "input": function($event) {
        _vm.newCustomView.VIN = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.newCustomView.referenceNumber,
      "type": "text",
      "placeholder": _vm.$t('Search.reference')
    },
    on: {
      "input": function($event) {
        _vm.newCustomView.referenceNumber = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.newCustomView.source,
      "type": "text",
      "placeholder": _vm.$t('Search.source')
    },
    on: {
      "input": function($event) {
        _vm.newCustomView.source = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.newCustomView.pickup,
      "type": "text",
      "placeholder": _vm.$t('Search.pickup')
    },
    on: {
      "input": function($event) {
        _vm.newCustomView.pickup = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.newCustomView.delivery,
      "type": "text",
      "placeholder": _vm.$t('Search.delivery')
    },
    on: {
      "input": function($event) {
        _vm.newCustomView.delivery = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.newCustomView.billing,
      "type": "text",
      "placeholder": _vm.$t('Search.billing')
    },
    on: {
      "input": function($event) {
        _vm.newCustomView.billing = $event
      }
    }
  }), _vm._v(" "), _c('regular-select', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.newCustomView.status,
      "placeholder": _vm.$t('Search.status.status')
    },
    on: {
      "change": function($event) {
        _vm.newCustomView.status = $event
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Dispatch"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.dispatch')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pick"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.pick')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Transit"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.transit')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Drop"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.drop')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Cancel"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.canceled')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Terminée"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.finished')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Transférée"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.transfered')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Reject"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.rejected')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Attente"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.waiting')))])]), _vm._v(" "), _c('regular-datalist-driver', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.newCustomView.driver,
      "secondList": _vm.liste,
      "placeholder": _vm.$t('Search.driver')
    },
    on: {
      "input": function($event) {
        _vm.newCustomView.driver = $event.value
      }
    }
  }), _vm._v(" "), _c('regular-select', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.newCustomView.provincePick,
      "placeholder": _vm.$t('OrderCurrent.modal.provinceOrigin')
    },
    on: {
      "change": function($event) {
        _vm.newCustomView.provincePick = $event
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "AB"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.AB')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BC"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.BC')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MB"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.MB')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NB"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.NB')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NL"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.NL')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NS"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.NS')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NT"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.NT')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NU"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.NU')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ON"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.ON')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PE"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.PE')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QC"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.QC')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SK"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.SK')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "YT"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.YT')))])]), _vm._v(" "), _c('regular-select', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.newCustomView.provinceDrop,
      "placeholder": _vm.$t('OrderCurrent.modal.provinceArrival')
    },
    on: {
      "change": function($event) {
        _vm.newCustomView.provinceDrop = $event
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "AB"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.AB')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BC"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.BC')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MB"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.MB')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NB"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.NB')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NL"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.NL')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NS"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.NS')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NT"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.NT')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NU"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.NU')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ON"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.ON')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PE"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.PE')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QC"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.QC')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SK"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.SK')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "YT"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.province.YT')))])]), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.newCustomView.dateReceptionMin,
      "type": "date",
      "placeholder": "Date min"
    },
    on: {
      "input": function($event) {
        _vm.newCustomView.dateReceptionMin = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.newCustomView.dateReceptionMax,
      "type": "date",
      "placeholder": "Date max"
    },
    on: {
      "input": function($event) {
        _vm.newCustomView.dateReceptionMax = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.newCustomView.afterXDays,
      "type": "number",
      "placeholder": _vm.$t('OrderCurrent.modal.after_x_days')
    },
    on: {
      "input": function($event) {
        _vm.newCustomView.afterXDays = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 form-group",
    attrs: {
      "value": _vm.newCustomView.beforeXDays,
      "type": "number",
      "placeholder": _vm.$t('OrderCurrent.modal.before_x_days')
    },
    on: {
      "input": function($event) {
        _vm.newCustomView.beforeXDays = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100",
    attrs: {
      "disabled": _vm.newCustomView.name === ''
    },
    on: {
      "click": function($event) {
        _vm.addCustomView()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('OrderCurrent.modal.confirm')) + "\n              ")])])], 1)])]) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.modal.deleteCustomView) ? _c('modal', {
    attrs: {
      "closable": ""
    },
    on: {
      "close-request": function($event) {
        _vm.modal.deleteCustomView = false;
        _vm.clear()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('OrderCurrent.sidebar.delete_custom_view')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('regular-select', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.selectedCustomView,
      "placeholder": _vm.$t('OrderCurrent.modal.custom_view')
    },
    on: {
      "change": function($event) {
        _vm.selectedCustomView = $event
      }
    }
  }, _vm._l((_vm.customViews), function(view) {
    return _c('option', {
      domProps: {
        "value": view['.key']
      }
    }, [_vm._v(_vm._s(view.query.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange",
    attrs: {
      "disabled": _vm.selectedCustomView === ''
    },
    on: {
      "click": function($event) {
        _vm.deleteCustomView()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('OrderCurrent.modal.confirm')) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.modal.deleteCustomView = false
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('OrderCurrent.modal.cancel')) + "\n                ")])])])], 1)])]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9b1a4f4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/OrderCurrent.vue
// module id = 850
// module chunks = 1